<script>
export default {
  name: "DidoResourcePaginatedAttachment",
};
</script>

<script setup>
import { computed } from "vue";
import { displayDateFormatDDMMYYYY } from "../../../utils";
import api from "../../../api";
import DidoTextTruncate from "../Truncate.vue";
import DidoDownloadButtonAttachment from "../../download/buttons/Attachment.vue";
import DidoDownloadButtonRef from "../../download/buttons/Ref.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  resource: { type: Object, required: true },
  type: { type: String, required: true },
});

// computed data for modification date if not refs
const modificationDate = computed(() => {
  if (props.type === "refs") return "";
  const dateToDisplay =
    props.resource.last_modified || props.resource.created_at;
  return displayDateFormatDDMMYYYY(dateToDisplay);
});
// computed data for publication date if not refs
const publicationDate = computed(() => {
  if (props.type === "refs") return "";
  if (props.resource.published)
    return displayDateFormatDDMMYYYY(props.resource.published);
  return "";
});

// computed data for ref or nomenc spec
const refOrNomenc = computed(() => {
  if (props.type !== "refs") return null;
  let refName,
    refFilters = [],
    refLabelFilters = [];
  if (typeof props.resource === "object")
    ({
      name: refName,
      filters: refFilters,
      labelFilters: refLabelFilters,
    } = props.resource);
  else refName = props.resource;
  return api.refs(props.apiUrl, refName, refFilters, refLabelFilters);
});
</script>

<template>
  <QCard tag="div" flat bordered square class="dido-dataset-resource">
    <template v-if="props.type === 'refs'">
      <!-- Title -->
      <div class="dido-dataset-resource-title">{{ refOrNomenc.title }}</div>
      <!-- Download link -->
      <div
        :class="`col-12 q-mt-sm row-start-center q-col-gutter-${
          $q.screen.gt.xs ? 'sm' : 'xs'
        } text-small`"
      >
        <!-- Download link -->
        <span>
          <DidoDownloadButtonRef
            :ref-or-nomenc="refOrNomenc"
            class="inline-block"
          />
        </span>
      </div>
    </template>
    <template v-else>
      <!-- Title -->
      <div class="dido-dataset-resource-title">{{ props.resource.title }}</div>
      <!-- Timestamps -->
      <div
        :class="`q-my-sm row-start-center q-col-gutter-${
          $q.screen.gt.xs ? 'sm' : 'xs'
        } text-small`"
      >
        <!-- Modification Date -->
        <span class="col-12 col-sm-auto">
          Modifié le {{ modificationDate }}
        </span>
        <!-- Separator -->
        <span v-if="$q.screen.gt.xs" class="col-0 col-sm-auto">|</span>
        <!-- Publication Date -->
        <span class="col-12 col-sm-auto">
          Publié le {{ publicationDate }}
        </span>
      </div>
      <!-- Description -->
      <div class="text-justify">
        <DidoTextTruncate
          :text="props.resource.description"
          :length="200"
          class="text-justify"
          :link-classes="[
            'cursor-pointer',
            'on-right',
            'text-primary',
            'text-underline',
            'text-small',
          ]"
        />
      </div>
      <!-- Donwloads information -->
      <div
        :class="`col-12 q-mt-sm row-start-center q-col-gutter-${
          $q.screen.gt.xs ? 'sm' : 'xs'
        } text-small`"
      >
        <!-- Download Counter -->
        <span class="col-12 col-sm-auto">
          Téléchargé {{ props.resource.downloads }} fois
        </span>
        <!-- Separator -->
        <span v-if="$q.screen.gt.xs" class="col-auto">|</span>
        <!-- Download Link -->
        <span class="col-12 col-sm-auto">
          <DidoDownloadButtonAttachment
            :api-url="props.apiUrl"
            :attachment="props.resource"
            class="inline-block"
          />
        </span>
      </div>
    </template>
  </QCard>
</template>
